import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { ModalContext } from "../../../../provider/ModalProvider";
import { COLUMN_DEFAULT } from "../../../../framework/grid/GridFw";
import { SubparametroResultadosRadiacionNoAcreModal } from "./SubparametroResultadosRadiacionNoAcre";

class CadenaRadiacionNoAcreditadoPage extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1"
    }
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this)
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    })
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () => pageApi.getComponent('gridDetalleMuestreo');
    const { TabPane } = Tabs;

    const ConfiguracionModalConfig = (data) => {
      const { showModal } = this.context;
      let obj = {};
      obj = { ...obj, data };

      showModal({
        width: 800,
        maskClosable: false,
        component: <SubparametroResultadosRadiacionNoAcreModal name={obj} getParentApi={pageApi.getApi} />
      });
    };

    const gridDetalleMuestreo = (pageApi) => ({
      title: '4. Detalle de muestreo',
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: 'ID_PARAMETRO',
      load: {
        queryId: 942,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
            id_doc: pageApi.name.id_ss
          }
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 932,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "MUESTRA", label: "Cod. Muestra" },
        { name: "tipo_ensayo", label: "Método" },
        { name: "estacion", label: "Estación" },
        { name: "descripcion", label: "Descripción" },
        {
          type: 'date',
          name: "FECHA_INICIAL",
          label: "Fecha Inicio",
          editable: true,
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: 'date',
          name: "HORA_INICIAL",
          label: "Hora Inicio",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm
        },
        {
          type: 'date',
          name: "FECHA_FIN",
          label: "Fecha Fin",
          editable: true,
          format: 'DD/MM/YYYY',
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: 'date',
          name: "HORA_FIN",
          label: "Hora Fin",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm
        },
        { name: 'georeferencia', label: 'Ubicación Geográfica' },
        { name: 'fuente_radiacion', label: 'Fuente de Radiación', type: 'text', editable: true },
        { name: 'bx', label: 'Bx', type: 'number', editable: true },
        { name: 'by', label: 'By', type: 'number', editable: true },
        { name: 'bz', label: 'Bz', type: 'number', editable: true },
        { name: 'tiempo_total_muestreo', label: 'Tiempo total de muestreo (min)', type: 'number', editable: true },
        { name: 'distancia_punto_medicion', label: 'Distancia al punto medición (m)', type: 'number', editable: true },
        { name: 'OBS', label: 'Observación', editable: true },
        {
          ...COLUMN_DEFAULT.CHECK, label: 'Opciones', title: 'Ingresar Resultados', onClick: (value, row) => {
            ConfiguracionModalConfig(row)
          }
        },
        {
          ...COLUMN_DEFAULT.ADD,
          label: "Replicar",
          color: "red",
          column: 12,
          onClick: async (value, row, index) => {
            await getgrid_detalle_muestreo().saveItemEditing();
            await getgrid_detalle_muestreo().refresh();
            const replicar = getgrid_detalle_muestreo()
              .getData()
              .map((data) => {
                data.fecha_prevista_muestreo = row.fecha_prevista_muestreo;
                data.hora_inicio_muestreo = row.hora_inicio_muestreo;
                data.zonificacion = row.zonificacion;
                data.fuente_ruido = row.fuente_ruido;
                data.tiempo_medicion = row.tiempo_medicion;
                return data;
              });
            getgrid_detalle_muestreo().setData(replicar);
          },
        }
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: 'grid'
      },
    ];

    return (
      <StickyContainer>
        <Tabs destroyInactiveTabPane={true} activeKey={this.state.keyPanel} renderTabBar={renderTabBar} onChange={(key) => this.setState({ keyPanel: key })}>
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Datos del Servicio" key="2" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DatosServisiosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Procedencia de la muestra" key="3" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <ProcedenciaMuestraModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Detalle del muestreo" key="4" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DetalleMuestreoModal api={pageApi} data={{ ...pageApi.name }} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} gridsConfig={gridsConfigDetalleMuestreo} />
          </TabPane>

          <TabPane tab="Equipos Utilizados" key="5" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <EquiposUtilizadosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Otros Datos" key="6" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <OtrosDatosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>
        </Tabs>
      </StickyContainer >
    );
  }
}

export default withRouter(CadenaRadiacionNoAcreditadoPage);